export default "__VITE_ASSET__R10YlwAq__"